/** eslint-disable-next-line */
import React from "react";
import { useDispatch } from "react-redux";

export default function WorkingInProgress() {
    const dispatch = useDispatch(); /** eslint-disable-next-line */
    dispatch({ type: "title", value: 'Trabalho em Andamento' });

    return (
        <div className='container-xxl flex-grow-1 container-p-y'>
            <h5>Pagina ainda em desenvolvimento</h5>

        </div>
    );
}
